;(function () {
  function marketCodeFromRegion(region) {
    if (region === 'eu_eea') return 'eu';
    if (region === 'usa_can') return 'us';
    if (region === 'aus_nz') return 'aus';
    if (region === 'uk' || region === 'roi' || region === 'row') return region;
    return 'row';
  }

  window.trMarketCodeFromRegion = marketCodeFromRegion;

  window.trActivatePolicyRegionPanels = function (root) {
    var container = root || document;
    if (!container || !container.querySelectorAll) return;

    var marketCode = marketCodeFromRegion(
      typeof window.trGetEffectiveRegion === 'function' ? window.trGetEffectiveRegion() : 'uk'
    );

    container.querySelectorAll('[data-tr-policy-region]').forEach(function (panel) {
      var isMatch = panel.getAttribute('data-tr-policy-region') === marketCode;
      panel.hidden = !isMatch;
    });
  };

  function refreshPolicyContent() {
    window.trActivatePolicyRegionPanels(document);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-show-modal]');
    if (!trigger) return;

    var modalId = trigger.getAttribute('data-show-modal');
    if (!modalId) return;

    var modal = document.getElementById(modalId);
    if (!modal || !modal.hasAttribute('data-tr-policy-modal')) return;

    window.trActivatePolicyRegionPanels(modal);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshPolicyContent);
  } else {
    refreshPolicyContent();
  }

  window.addEventListener('tr:country-change', refreshPolicyContent);
})();
